import UnitDetailModal from './UnitDetailModal';
export default UnitDetailModal;
